<template>
  <el-dialog
    title="关联课件"
    width="60%"
    :visible="dialogVisible"
    append-to-body="true"
    @close="$emit('close')">
    <div class="courseware-filter">
      <el-row>
        <el-col :span="6">
          <el-input @keyup.enter.native="getList" class="courseware-filter-value" placeholder="课件名称" v-model.trim="search.name" size="small" clearable suffix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :span="6">
          <el-select v-model="search.type" @change="getList" clearable placeholder="选择课件类型" size="small" filterable :disabled="selectedType !== undefined">
            <el-option
              v-for="(item, index) in coursewareType"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="search.groupId" @change="getList" clearable placeholder="选择课件分组" size="small" filterable>
            <el-option
              v-for="(item, index) in coursewareGroups"
              :key="index"
              :label="item.groupName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="courseware-filter-reset" size="small" @click="getList">立即筛选</el-button>
            <el-button class="courseware-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <avue-crud
      ref="crud"
      :page.sync="page"
      :data="tableData"
      :table-loading="tableLoading"
      :option="option"
      @current-change="currentChange"
      @size-change="sizeChange"
      @selection-change="selectionChange"
      @row-click="rowClick">

      <template slot="radio" slot-scope="{row}">
        <el-radio v-model="selectedCoursewareId" :label="row.id"></el-radio>
      </template>

      <template slot="name" slot-scope="{row}">
        <div class="name">
          <div class="cover-image" v-if="row.coverUrl">
            <img :src="row.coverUrl">
          </div>
          <span class="click" @click="getCoursewareDetail(row.id)">{{row.name}}</span>
        </div>
      </template>

    </avue-crud>
    <span class="dialog-footer" slot="footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="handleConfirmSelect">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fetchCoursewareList, fetchCoursewareGroupList } from '@/api/app/course'
import { coursewareTypeOptions } from '@/const/crud/app/course';
import { formatCoursewareLength, formatTime } from '../../courseware/util/index';

export default {
  name: 'CoursewareSelector',
  props: {
    dialogVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    selectedCoursewares: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedType: {
      type: Number,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      selectedCourseware: {},
      selectedCoursewareId: {},
      tableLoading: false,
      search: {
        name: '',
        type: this.selectedType,
        groupId: undefined,
      },
      coursewareGroups: [],
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      coursewareType: coursewareTypeOptions,
      option: {
        tip: false,
        border: true,
        stripe: true,
        menuAlign: 'center',
        align: 'center',
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        viewBtn: false,
        menu: false,
        column: [
          {
            label: '',
            prop: 'radio',
            width: 60,
            solt: true,
          },
          {
            label: 'ID',
            prop: 'id',
            width: 100,
            overHidden: true,
          },
          {
            label: '名称',
            prop: 'name',
            width: 180,
            overHidden: true,
            solt: true,
          },
          {
            label: '课程类型',
            prop: 'type',
            width: 110,
            dicData: coursewareTypeOptions
          },
          {
            label: '课件长度',
            prop: 'coursewareLength',
            width: 110,
          },
          {
            label: '建议学习时长',
            prop: 'coursewareTime',
            width: 110,
          },
          {
            label: '分组',
            prop: 'coursewareGroupName',
            width: 180,
          },
          {
            label: '描述',
            prop: 'description',
            overHidden: true,
          },
        ]
      },
    }
  },
  created() {
    this.getList();
    this.getCoursewareGroups();
  },
  methods: {
    getCoursewareDetail(id) {
      const routeData =this.$router.resolve({
        path: `/app/course/courseware/detail/${id}`,
      });
      window.open(routeData.href,'_blank');
    },
    rowClick(row) {
      this.selectedCourseware = row;
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    sizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    selectionChange(list){
      this.selectedCoursewares = list;
    },
    toggleSelection(val){
      this.$refs.crud.toggleSelection(val);
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach(record => {
          record.coursewareLength = !record.coursewareLength ? '--' : formatCoursewareLength(record.type, record.coursewareLength);
          record.coursewareTime = !record.coursewareTime ? '--': formatTime(record.coursewareTime);
          record.coursewareGroupName = !record.coursewareGroupName ? '--': record.coursewareGroupName;
          record.description = !record.description ? '--': record.description;
        })
      }
      return records;
    },
    getCoursewareGroups() {
      fetchCoursewareGroupList().then(response =>{
        if (response.data.code === 0) {
          this.coursewareGroups = response.data.data;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    getList() {
      this.tableLoading = true
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        keyword: this.search.name,
        type: this.search.type,
        coursewareGroupId: this.search.groupId,
      }
      fetchCoursewareList(params).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
        const selectedCoursewareIds = this.selectedCoursewares.map(courseware => courseware.coursewareId);
        this.selectedCoursewares = this.tableData.filter(courseware => {
          return selectedCoursewareIds.includes(courseware.id);
        });
        this.$nextTick(() => {
          this.toggleSelection(this.selectedCoursewares);
        });
      }).catch(error => {
        console.error(error);
        this.$message({
          message: '获取课件列表失败',
          type: 'error'
        });
        this.tableLoading = false;
      })
    },
    searchReset() {
      this.search.name = '';
      this.search.type = undefined;
      this.search.groupId = undefined;
      this.getList();
    },
    handleConfirmSelect() {
      this.$emit('close');
      this.$emit('confirm-select', this.selectedCourseware);
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ thead .el-checkbox {
  display: none;
}

/deep/ .el-radio__label {
  display: none;
}

/deep/ .el-radio__inner {
  border: 1px solid #58779b;
}

/deep/ .avue-crud__menu {
  display: none;
}

.name {
  display: flex;
  align-items: center;
  color: #606266;
  .cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.click {
  color: #5383f3;
  cursor: pointer;
}

.courseware-filter {
  margin: 0 10px;
  border-bottom: 1px solid #ccd0d8;
  /deep/ .el-input__inner {
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;

  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>
